import { Button, Form, Input, Radio, Space, Select, Row, Col, Avatar, Switch, Tooltip, Upload, Tabs } from 'antd';
import { Badge, FloatingLabel } from 'flowbite-react';
import { UserOutlined } from '@ant-design/icons';
import React, { useEffect, useState } from 'react';
import { FaSave } from 'react-icons/fa';
import { Link, useParams, useLoaderData, useOutletContext, useNavigate } from 'react-router-dom';
import { FaCloudArrowUp } from 'react-icons/fa6';
import { MdEdit } from 'react-icons/md';
import { RxUpdate } from "react-icons/rx";
import EventEmitter from '../../utils/eventEmitter';
import useContactAPI from '../apis/contactsAPI';
import ContactAddress from '../modals/ContactAddress';
import { ACCOUNTING_URL } from '../../utils/axios';
import axios from 'axios';
import { errorModal } from '../modals/ModalMessages';



// const address_type = [
//   {value: '', label: ''},
//   {value: 'contact', label: 'Contact'},
//   {value: 'invoice_address', label: 'Invoice Address'},
//   {value: 'delivery_address', label: 'Delivery Address'},
//   {value: 'Other address', label: 'Other Address'},
//   {value: 'private_address', label: 'Private Address'}
// ]


const PosSessionCustomerChanges = () => {
  const {contact, companies, titles, tags} = useLoaderData();
  const { success, error } = useOutletContext();
  const [form] = Form.useForm();
  const params = useParams();
  const navigate = useNavigate();
  const [name, setName] = useState(contact.name ? contact.name : '');
  const [contactType, setContactType] = useState(contact.type ? contact.type: 'individual');
  const { create, update } = useContactAPI();
  const [accounts, setAccounts] = useState([]);

  const onChangeName = (e) => setName(e.target.value);
  const toggleContactType = e => setContactType(e.target.value);

  const save = () => {
    let data = form.getFieldsValue();
    if (name && data.phone_number1) {
      data['name'] = name;
      const { city, region, street_address, street2 } = data.address;
      data['street_address'] = street_address;
      delete data.address;
      create(data, success);
    }else {
      errorModal('CONTACT CREATION FAILED', 
      <p>
        Cusotmer name and phone number are required
      </p>);
    }
    // console.log(data);
  }

  const edit = () => { 
    let data = form.getFieldsValue();
    data['name'] = name;
    const { city, region, street_address, street2 } = data.address;
    data['street_address'] = street_address;
    delete data.address;
    update(contact.seo, data, success);
    // console.log(data)
  };

  useEffect(() => {
    EventEmitter.subscribe('contact_created', data => {
      navigate(-1);
    });
    
    return () => EventEmitter.unsubscribe('contact_created');
  },[])


  // useEffect(() => {
  //   axios.get(ACCOUNTING_URL+'accounts/expose/other-modules')
  //   .then(res => setAccounts(res.data))
  //   .catch(err => console.log(err))
  // },[])

  return (
    <div className='container mx-2'>
      <div className='flex justify-between'>
        <div>
          {!contact.seo && <Tooltip  title='save manually' placement='rightBottom' className='ms-1'>
            <Button onClick={save} type='text' htmlType='button'
              disabled={contact.seo ? true : false}
              className='border-0 bg-transparent focus:bg-transparent'
              icon={<FaCloudArrowUp />}
            />
          </Tooltip>}
          {contact.seo && <Button htmlType='button' onClick={edit} icon={<RxUpdate />}>UPDATE</Button>}
        </div>
        
      </div>  
      <div className='mt-5 p-3 bg-white shadow p-3'>
        
        <Form 
          form={form}
          labelAlign='left'
          labelCol={{ span: 5}}
          labelWrap={true}
          initialValues={contact.seo ? {...contact, address: {street_address: contact.street_address}} : { type: 'individual'}}
          // disabled={formValue.status!== 'discard' ? true : false}
          autoComplete="off"
          variant='borderless'
        >
          <Form.Item name="type" className="font-bold mb-1" required>
            <Radio.Group onChange={toggleContactType}>
              <Space >
                <Radio value="individual">Individual</Radio>
                <Radio value="company">Company</Radio>
              </Space>
            </Radio.Group>
          </Form.Item>
          
          <Row>
            <Col  md={{ span: 24 }}>
              <FloatingLabel
                className='text-2xl'
                variant="standard"
                // disabled={formValue.status!== 'discard' ? true : false}
                placeholder="Name"
                value={name} 
                onChange={onChangeName}
              />
              {contactType === 'individual' && <Form.Item name={'company_id'}>
                <Select options={companies.map(company => ({value: company.id, label: company.name}))} placeholder='company'/>
              </Form.Item>}
            </Col>
            {/* <Col md={{ span: 3, offset: 9 }}>
              <Upload 
                name="picture"
                listType="picture-card"
                className="avatar-uploader"
                showUploadList={false}
                style={{height: '30px'}}
                
              >
                <Avatar icon={<UserOutlined />} />
              </Upload>
            </Col> */}
          </Row>

          <Row>
            <Col md={{span: 11}}>
              <Form.Item label='Phone' name="phone_number1" className='font-bold mb-1' required >
                <Input type='tel' maxLength={10} className='input-outline-none font-normal py-1' placeholder='0123456789'/>
              </Form.Item>
              {/* {contactType === 'individual' && <Form.Item label='Address Type' name="address_type" className='font-bold mb-1' required >
                <Select options={address_type}/>
              </Form.Item>}
             */}
              {/* <Form.Item label='Address' className='font-bold mb-1' required >
                <Space.Compact direction='vertical'>
                  <Form.Item name={['address', 'street_address']} noStyle className='mb-1'>
                    <Input type='text' className='input-outline-none font-normal' placeholder='street 1' name='street_address' />
                  </Form.Item>
                </Space.Compact>
                <Row>
                  <Col md = {{span: 11}}>
                    <Form.Item name={['address', 'region']} noStyle className='mb-1'>
                      <Select options={[]} placeholder='region' name='region' className='font-normal' />
                    </Form.Item>
                  </Col>
                  <Col md = {{span: 11, offset: 2}}>
                    <Form.Item name={['address', 'city']} noStyle className='mb-1'>
                      <Select options={[]} placeholder='city' name='city' className='font-normal'/>
                    </Form.Item>
                  </Col>
                </Row>
              </Form.Item>  */}
              
              
            </Col>
            {/* <Col md={{span: 11, offset: 1}}>
              <Form.Item label='Phone' name="phone_number1" className='font-bold mb-1' required >
                <Input type='tel' maxLength={10} className='input-outline-none font-normal py-1' placeholder='0123456789'/>
              </Form.Item>
              <Form.Item label='Email' name="email" className='font-bold mb-1' required >
                <Input type='email' className='input-outline-none font-normal py-1' placeholder='johndoe@email.com' />
              </Form.Item>
            </Col> */}
          </Row>
        </Form>
      </div>
      <ContactAddress />
    </div>
  )
}

export default PosSessionCustomerChanges;